// extracted by mini-css-extract-plugin
export var filterIncDec = "_c9-0";
export var leftBorder = "_c9-1";
export var rightBorder = "_c9-2";
export var stringInput = "_c9-3";